import { DataBean } from "../DataBean";

export class ConceptCatalogByProcess extends DataBean {


    public async getAccountantConceptCatalogByProcess(processType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getAccountantConceptCatalogByProcess_Number", [processType]);
    }

}